<template>
  <b-container fluid class="editProduct">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          <i class="material-icons smallIcon" v-on:click="goBack">arrow_back_ios</i>
          Edit Product
        </div>
      </b-col>
    </b-row>
    <b-row v-if="editingProduct != null && editingProduct.attributes != null" class="m-4">
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Product Name
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="text" placeholder="Product Name" v-model="editingProduct.attributes.name">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Description
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="text" placeholder="Description" v-model="editingProduct.attributes.description">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Image
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <img v-if="editingProduct.attributes.image != null" :src="getImage(editingProduct.attributes.image.data.attributes.url, 'url')" style="width: 500px;">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Change Image
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="file" multiple :name="productImage" :disabled=false
          @change="filesChange($event.target.name, $event.target.files[0]); fileCount = $event.target.files.length"
          accept="image/*">
      </b-col>
      <b-col lg="12" md="12" sm="12" xs="12" class="submitBtn text-left">
        <div class="p-3 text-center text-uppercase" v-on:click="editProduct(editingProduct)">
          Edit
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'EditProduct',
  data () {
    return {
      isLoading: false,
      errors: [],
      productSection: 'products',
      image: null,
      productImage: {}
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    filesChange (filename, file) {
      console.log('filename: ' + filename + '. file: ' + file)
      this.$data.image = file
    },
    findProductById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findProductById', {
        data: {
          id: id
        },
        success: (res) => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
          console.log('failed get product by id')
          this.$router.push('/dproducts')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    editProduct (product) {
      // if (this.$data.image.name !== undefined) {
      //   if (product.images[0] != null) {
      //     product.deleteImages = [product.images[0].id]
      //   }
      //   product.images = this.$data.image
      // }
      if (this.validateProduct(product)) {
        this.$store.dispatch('editProduct', {
          data: {
            id: product.id,
            product: {
              name: product.attributes.name,
              description: product.attributes.description
            },
            token: this.$cookies.get('a').jwt
          },
          success: () => {
            if (this.$data.image != null) {
              this.uploadFile(product.id, this.$data.image)
              const deleteImageId = product.attributes.image.data.id
              this.deleteFile(deleteImageId)
            } else {
              this.$router.push('/dproducts')
            }
            this.toast('Edit success.', 'success', 'check')
          },
          fail: () => {
            this.toast('Edit failed. Try again later.', 'error', 'error_outline')
          }
        })
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline')
        this.isLoading = false
      }
    },
    validateProduct (product) {
      return true
    },
    deleteFile (id) {
      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.$router.push('/dproducts')
        },
        fail: () => {
          this.toast('Image delete failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    uploadFile (id, files) {
      const fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-product.dsk-product',
        field: 'image'
      }
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
        },
        fail: () => {
          this.toast('Image upload failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  },
  created () {
    this.findProductById(this.$route.params.id)
  },
  computed: {
    ...mapGetters([
      'editingProduct'
    ])
  }
}
</script>

<style scoped>
.editProduct {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  margin-bottom: 10px;
}
.box input {
  outline: none;
  width: 100%;
}
.submitBtn {
  background-color: #FF8F00;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.submitBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
.questionBox {
  padding-left: 0px;
  padding-right: 0px;
}
.answerBox {
  border-bottom: 1px solid #000;
}
.answerBox input {
  border: none;
}
.smallIcon {
  font-size:1em;
}
.smallIcon:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EditProduct.vue